<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Company Machine</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form row segment" @submit.prevent="companyMachineUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>Company</label>
            <div class="ui fluid search selection dropdown" id="CompanySelect">
              <input
                type="hidden"
                name="company"
                v-model="companyId"
                id="company"
                @change="onCompanyChange"
              />
              <div class="default text">Company</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="company in companies"
                  v-bind:data-value="company.value"
                  :key="company.id"
                >
                  {{ company.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Machine</label>
            <div class="ui fluid search selection dropdown" id="MachineSelect">
              <input
                type="hidden"
                name="machine"
                v-model="machineId"
                id="machine"
                @change="onMachineChange"
              />
              <div class="default text">Machine</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="machine in machines"
                  v-bind:data-value="machine.value"
                  :key="machine.id"
                >
                  {{ machine.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Machine Description</label>
            <input
              type="text"
              name="MachineDescription"
              placeholder="Machine Description"
              v-model="machine.description"
              disabled="disabled"
              class="disabled field"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Serial Number</label>
            <input
              type="text"
              name="SerialNumber"
              placeholder="Serial Number"
              v-model="serialNumber"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Machine Code Word</label>
            <input
              type="text"
              name="MachineCode"
              placeholder="Machine Code Word"
              v-model="code"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="active" class="toggle label">Inactive</label>
            <div class="ui toggle checkbox">
              <input
                id="active"
                name="active"
                type="checkbox"
                tabindex="0"
                class
                v-model="active"
              />
              <label for="active">Active</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{button}} Machine</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>

          <div class="eight wide column">
            <div class="ui primary button right floated" @click="deleteModal">
              Delete Machine
            </div>
          </div>
        </div>
      </div>
    </form>
    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">Are you sure you want to delete this machine?</div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div
          class="ui positive right labeled icon button"
          @click="companyMachineDelete(id)"
        >
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

import SemanticModal from "vue-ya-semantic-modal";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "ManageCompanyMachineDetails",
  computed: {},
  components: {
    SemanticModal: SemanticModal(),
  },
  mounted() {
    this.getMachineSelectedItems();
    this.getCompanySelectedItems();

    $(".ui.dropdown").dropdown({
      fullTextSearch: true,
      sortSelect: true,
      match: "text",
    });

    if (this.$route.params.id == undefined) {
      $(".ui.dropdown .remove.icon").on("click", function(e) {
        $(this)
          .parent(".dropdown")
          .dropdown("clear");
        e.stopPropagation();
      });
      
      this.button = 'Add';
      this.title = 'Add';
    } else {
      this.companyMachineDetails();
      this.button = 'Save';
      this.title = 'Edit';
    }
  },
  data() {
    return {
      hideNegligibleFractionDigits: false,
      hideCurrencySymbol: false,
      hideThousandsSeparatorSymbol: false,
      showModal: false,
      description: "",
      code: "",
      serialNumber: "",
      machine: "",
      machines: [],
      machineId: "",
      company: "",
      companies: [],
      companyId: "",
      active: false,
      error: "",
      button: "",
      title: ""
    };
  },
  methods: {
    deleteModal() {
      this.showModal = !this.showModal;
    },
    onMachineChange(event) {
      this.machineId = event.target.value;
    },
    onCompanyChange(event) {
      this.companyId = event.target.value;
    },
    getMachineSelectedItems() {
      apiService.getMachinesList().then((data) => {
        this.machines = data;

        $(".ui.dropdown").dropdown({
          fullTextSearch: true,
          sortSelect: true,
          match: "text",
        });
      });
    },
    getCompanySelectedItems() {
      apiService.getCompaniesList().then((data) => {
        this.companies = data;

        $(".ui.dropdown").dropdown({
          fullTextSearch: true,
          sortSelect: true,
          match: "text",
        });

        let _this = this;
        if (this.companyId != null) {
          setTimeout(function() {
            $("#CompanySelect").dropdown("set selected", _this.companyId);
          }, 1500);
        }
      });
    },
    companyMachineDetails() {
      apiService
        .getCompanyMachineDetails({ id: this.$route.params.id })
        .then((request) => {
          this.machineId = request.machineId;
          this.companyId = request.companyId;
          this.companyMachineSuccessful(request);

          this.setDropdowns();
          let _this = this;
          setTimeout(function() {
            $("#MachineSelect").dropdown("set selected", _this.machineId);
            $("#CompanySelect").dropdown("set selected", _this.companyId);
          }, 2000);
        })
        .catch((err) => this.companyMachineFailed(err));
    },
    companyMachineSuccessful(request) {
      (this.description = request.description),
        (this.code = request.code),
        (this.serialNumber = request.serialNumber),
        (this.machine = request.machine),
        (this.machineId = request.machineId),
        (this.company = request.company),
        (this.companyId = request.companyId),
        (this.active = request.active);
    },
    companyMachineFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    companyDropdown() {
      setTimeout(function() {
        $("#CompanySelect").dropdown("set selected", this.companyId);
      }, 1500);
    },
    setDropdowns() {
      this.companyDropdown();
    },
    companyMachineDelete() {
      apiService
        .deleteCompanyMachine({ id: this.$route.params.id })
        .then((request) => {
          this.companyMachineSuccessful(request);
          this.showModal = !this.showModal;
          this.$router.push("/admin/company/machines");
        })
        .catch((err) => this.companyMachineFailed(err));
    },
    companyMachineUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createCompanyMachine({
            description: this.description,
            code: this.code,
            serialNumber: this.serialNumber,
            machineId: this.machineId,
            companyId: this.companyId,
            active: this.active,
          })
          .then((request) => {
            // console.log(this.active);

            this.companyMachineSuccessful(request);
            this.$router.push("/admin/company/machines");
          })
          .catch((err) => this.companyMachineFailed(err));
      } else {
        // console.log('edit');
        apiService
          .updateCompanyMachine({
            id: this.$route.params.id,
            description: this.description,
            code: this.code,
            serialNumber: this.serialNumber,
            machineId: this.machineId,
            companyId: this.companyId,
            active: this.active,
          })
          .then((request) => {
            this.companyMachineSuccessful(request);
            this.$router.push("/admin/company/machines");
          })
          .catch((err) => this.companyMachineFailed(err));
      }
    },
  },
};
</script>

<style module></style>
